module.exports = __webpack_public_path__ + "static/media/relative.306e6e2c.svg";